/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.
Este software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR
 y sus afiliadas. ("Información Confidencial"). Usted no puede divulgar dicha Información Confidencial, 
 y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/

/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.
This software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información 
MALMUR and its affiliates. ("Confidential Information"). You may not disclose such Confidential Information, 
and may only use such Confidential Information in accordance with the terms of the license agreement you entered 
into with MALMUR.*/

import FormField from "components/generals/FormInput";
import FormikForm from "components/layout/FormikForm";
import { FieldArray, Form, FormikProps, FormikState } from "formik";
import {
  getSelectOptions,
  personFormYUPValidation,
  personParentFormYUPValidation,
  validatePhoneInputSymbol,
} from "utils/form.utils";
import { FormProps } from "../../interfaces";
import {
  AssetInterface,
  HeaderEnum,
  MediaCategoryEnum,
  MediaSourceEnum,
  MediaStatusEnum,
  PersonInterface,
  PersonPrefixEnum,
  PersonRelationInterface,
  PersonRelationType,
  PersonSuffixEnum,
  QueryResultInterface,
  UserRolesEnum,
} from "medicalsystem-shared";
import { getFromISOYYYYMMDDDateFormat, verifyIsMinor } from "utils/date.utils";
import useHttp from "hooks/http.hook";
import StepperFormActionButtons from "./custom/StepperFormActionButtons";
import Typography from "components/generals/Typography";
import FolderSharedIcon from "@mui/icons-material/FolderShared";
import DatePicker from "components/generals/DatePicker";
import { ChangeEvent, SyntheticEvent, useEffect, useMemo, useState } from "react";
import Box from "components/generals/Box";
import Checkbox from "components/generals/FormInputCheckbox";
import { CoreAPI_URLs } from "constants/http.const";
import { FormActionType, SelectArrayType } from "types";
import { Method } from "axios";
import FormSelectInput from "components/generals/FormSelectInput";
import Button from "components/generals/Button";
import { useTranslation } from "react-i18next";
import userIcon from "dashboard-template/assets/images/userIcon.png";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  Divider,
  Stack,
  Autocomplete,
  TextField,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  CircularProgress,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import { ExtendedPersonInterface } from "interfaces";
import { getNewParentDataContent } from "utils/model.utils";
import { AutoCompleteOption } from "types/form.enum";
import InputFileUpload from "components/generals/InputFileUpload";
import Avatar from "components/generals/Avatar";
import FormPhoneInput from "components/generals/FormPhoneInput";
import { calculateAge } from 'utils/generic.utils';
import { checkFormValidity } from 'utils/form.utils';
import { useAuthenticatedAsset } from 'hooks/useAuthenticatedAsset.hook';
import { eventAction, useAppDispatch } from 'store/store';

//TODO: REFACTOR METHOD VERY COMPLEX
/**
 * Comprehensive person demographic and contact information form.
 * 
 * Features:
 * - Complete demographic data capture:
 *   - Name (prefix, first, middle, last, suffix)
 *   - Date of birth with age calculation
 *   - Gender, ethnicity, race
 *   - SSN and identification numbers
 *   - Preferred language
 * - Contact information:
 *   - Multiple phone numbers (home, work, mobile)
 *   - Multiple email addresses
 *   - Physical address (street, city, state, ZIP, country)
 * - Family relationships:
 *   - Parent/guardian management for minors
 *   - Relationship type selection
 *   - Emergency contact designation
 * - Profile image upload:
 *   - Photo capture and upload
 *   - Authenticated asset storage
 *   - Image preview
 * - Minor patient handling:
 *   - Automatic parent/guardian requirement
 *   - Age-based validation
 * - Address autocomplete
 * - Phone number validation and formatting
 * - Form validation with Yup schema
 * - Stepper integration for multi-step workflows
 * - Permission-based field access
 * 
 * Relationship Management:
 * - Add/edit/delete parent/guardian relationships
 * - Search existing persons as parents
 * - Create new parent records inline
 * - Relationship type (mother, father, guardian, etc.)
 * 
 * @param model - Person data to edit (or new person template)
 * @param action - Form action (NEW, MODIFY)
 * @param nextStep - Callback for stepper next step
 * @param backStepHandler - Callback for stepper previous step
 * @param firstStep - Flag indicating first step in stepper
 * @param type - Person type context
 * @param parentsRelationList - List of existing parent relationships
 * @param comesFromTable - Flag indicating inline table editing
 * @param updateListHandler - Callback to refresh parent person list
 * @param setImage - Callback to update profile image
 * @returns Person demographic form with relationship management
 */
const PersonForm: React.FC<FormProps<PersonInterface>> = ({
  model,
  action,
  nextStep,
  backStepHandler,
  firstStep,
  type,
  parentsRelationList,
  comesFromTable,
  updateListHandler,
  setImage,
}) => {
  const [isLoading, _error, sendRequest] = useHttp();
  const dispatch = useAppDispatch();
  const [existPersonChecked, setExistPersonChecked] = useState(false);
  const [minorUserChecked, setMinorUserChecked] = useState(false);
  const [addUserParentChecked, setAddUserParentChecked] = useState(false);
  const [differentAddressChecked, setDifferentAddressChecked] = useState(false);
  const [emergencyContactsChecked, setEmergencyContactsChecked] = useState(false);
  const [personList, setPersonList] = useState<PersonInterface[]>([]);
  const [selectedPerson, setSelectedPerson] = useState<PersonInterface>();
  const [selectedPersons, setSelectedPersons] = useState<ExtendedPersonInterface[]>([]);
  const [openErrorModal, setOpenErrorModal] = useState(false);
  const [openErrorMiniorModal, setOpenErrorMiniorModal] = useState(false);
  const [openErrorAddModal, setOpenErrorAddModal] = useState(false);
  const [openErrorGuardianModal, setOpenErrorGuardianModal] = useState(false);
  const parentData = useMemo<ExtendedPersonInterface>(() => getNewParentDataContent(), []);
  const [mainPersonRelationIds, setMainPersonRelationIds] = useState<string[]>([]);
  const [messageUsernameFlag, setMessageUsernameFlag] = useState(false);
  const [minior, setMinior] = useState(true);
  const [openConfirmDeleteModal, setOpenConfirmDeleteModal] = useState(false);
  const [openErrorDeleteGuardianModal, setOpenErrorDeleteGuardianModal] = useState(false);
  const [personToDelete, setPersonToDelete] = useState<string | null>(null);
  const [newImage, setNewImage] = useState<File | null>(null);
  const { t } = useTranslation();
  const [readyForPicker, setReadyForPicker] = useState(true);
  const [previewImageUrl, setPreviewImageUrl] = useState<string | null>(null);
  const [photoUpdateKey, setPhotoUpdateKey] = useState(0);

  // Use authenticated asset hook for profile photo
  // Include photoUpdateKey to force re-execution when photo is updated
  const { blobUrl: currentPhotoUrl, isLoading: photoLoading, progress } = useAuthenticatedAsset(
    model.photo,
    photoUpdateKey
  );
  const [datePickerKey, setDatePickerKey] = useState(0);
  const [formKey, setFormKey] = useState(0);
  const [preservedFormValues, setPreservedFormValues] = useState<Partial<PersonInterface> | null>(null);

  useEffect(() => {
    if (openErrorModal) {
      setReadyForPicker(false);
    } else {

      const timeout = setTimeout(() => {
        setReadyForPicker(true);
      }, 300);

      return () => clearTimeout(timeout);
    }
  }, [openErrorModal]);

  useEffect(() => {
    const anyModalOpen =
      openErrorModal ||
      openErrorMiniorModal ||
      openErrorAddModal ||
      openErrorGuardianModal ||
      openConfirmDeleteModal ||
      openErrorDeleteGuardianModal;

    if (anyModalOpen) {
      setReadyForPicker(false);
      return;
    }

    const timeout = setTimeout(() => {
      setReadyForPicker(true);
    }, 300);

    return () => clearTimeout(timeout);
  }, [openErrorModal, openErrorMiniorModal, openErrorAddModal, openErrorGuardianModal, openConfirmDeleteModal, openErrorDeleteGuardianModal]);

  useEffect(() => {
    if (model.dob) {
      const age = calculateAge(getFromISOYYYYMMDDDateFormat(new Date(model.dob)));
      setMinior(age < 21);
    }
  }, [model.dob]);

  useEffect(() => {
    sendRequest(CoreAPI_URLs.PERSONS_GET_ALL, onGetPersonHandler, "GET");
    if (model.emergencyContacts?.length > 0) {
      setEmergencyContactsChecked(true);
    }
    
    if (model.dob) {
      const age = calculateAge(getFromISOYYYYMMDDDateFormat(new Date(model.dob)));
      setMinior(age < 21);
    }
    
    const hasExistingRelations = parentsRelationList && parentsRelationList.length > 0;
    const isMinorWithoutIdentity = model.isActive && !model.identity;
  
    if (hasExistingRelations || isMinorWithoutIdentity) {
      setMinorUserChecked(true);
      let validRelations: PersonRelationInterface[] = [];
      if (parentsRelationList && parentsRelationList.length > 0) {
        validRelations = parentsRelationList.filter(relation => 
          relation && 
          relation.grantee && 
          relation.grantee.name && 
          relation.grantee.lastname
        );
      }
      if (validRelations.length > 0) {
        const baseParentPerson = validRelations.map((relation) => {
          const { grantee, relationship, customRelationship, comments, mainGrantee } = relation;
  
          if (relation.mainGrantee === true) {
            setMainPersonRelationIds((prevIds) => [...prevIds, "local_" + grantee.id]);
          }
  
          const transformedPerson = {
            name: grantee.name || "",
            lastname: grantee.lastname || "",
            phones: grantee.phones || [],
            phone: grantee.phones?.[0]?.number || "",
            username: grantee.user?.username || "NA",
            email: grantee.user?.email || "NA",
            dob: grantee.dob || "",
            sex: grantee.sex || "",
            identity: grantee.identity || "",
            address: grantee.address || "",
            city: grantee.city || "",
            state: grantee.state || "",
            county: grantee.county || "",
            country: grantee.country || "",
            zip: grantee.zip || "",
            relationship: relationship || "",
            other: customRelationship || "",
            comment: comments || "",
            idlocal: `local_${grantee.id}`,
            existAccount: !!grantee.user,
            responsible: Boolean(mainGrantee),
          };
          return transformedPerson;
        });
        
        setTimeout(() => {
          setSelectedPersons(baseParentPerson);
        }, 0);
      } else {
        setSelectedPersons([]);
      }
    } else {
      setMinorUserChecked(false);
      setSelectedPersons([]);
    }
  }, [model.dob, parentsRelationList]);

  const isEffectiveLastStep = useMemo<boolean>(
    () => selectedPerson !== undefined || existPersonChecked,
    [selectedPerson, existPersonChecked]
  );

  const sexListOptions = useMemo<SelectArrayType[]>(() => {
    const optionList: SelectArrayType[] = [];
    optionList.push({ label: t("personForm.male"), value: "MALE" });
    optionList.push({ label: t("personForm.female"), value: "FEMALE" });
    return optionList;
  }, []);

  const prefixListOptions = useMemo<SelectArrayType[]>(
    () => getSelectOptions(PersonPrefixEnum, t),
    []
  );

  const suffixListOptions = useMemo<SelectArrayType[]>(
    () => getSelectOptions(PersonSuffixEnum, t),
    []
  );

  const relationshipOptions = useMemo<SelectArrayType[]>(
    () => getSelectOptions(PersonRelationType, t),
    []
  );

  const prefixSelectOptions = useMemo(() => [
    { value: null, label: t("personForm.selectNone") },
    ...prefixListOptions,
  ], [t, prefixListOptions]);

  const suffixSelectOptions = useMemo(() => [
    { value: null, label: t("personForm.selectNone") },
    ...suffixListOptions,
  ], [t, suffixListOptions]);

  const onGetPersonHandler = (data: QueryResultInterface<PersonInterface>) => {
    if (data && data.results && Array.isArray(data.results)) {
      const validPersons = data.results.filter(person => 
        person && 
        person.id && 
        (person.name || person.lastname)
      );
      setPersonList(validPersons);
    } else {
      setPersonList([]);
    }
  };

  const existsPersonelCheckHandler = (event: ChangeEvent<HTMLInputElement>) => {
    const checked = event.currentTarget.checked;
    setExistPersonChecked(checked);
    if (!checked) {
      setSelectedPerson(undefined);
    }
  };

  const minorUserCheckHandler = (event: ChangeEvent<HTMLInputElement>) => {
    const checked = event.currentTarget.checked;
    setMinorUserChecked(checked);
  };

  const emergencyContactsCheckHandler = (event: ChangeEvent<HTMLInputElement>) => {
    const checked = event.currentTarget.checked;
    setEmergencyContactsChecked(checked);
  };

  const differentAddressCheckHandler = (event: ChangeEvent<HTMLInputElement>) => {
    const checked = event.currentTarget.checked;
    setDifferentAddressChecked(checked);
  };

  const handleResponsibleChange = (idlocal) => {
    const exist = mainPersonRelationIds.includes(idlocal);
    const lengthRelationList = mainPersonRelationIds.length;

    if (exist) {
      setMainPersonRelationIds((prevIds) => prevIds.filter((id) => id !== idlocal));
    } else if (lengthRelationList < 2) {
      setMainPersonRelationIds((prevIds) => [...prevIds, idlocal]);
    }
  };

  const handleConfirmDelete = (personId: string) => {
    const remainingGuardians = selectedPersons.filter(person => person.idlocal !== personId);
    
    if (remainingGuardians.length === 0) {
      setOpenErrorDeleteGuardianModal(true);
      return;
    }
    
    setPersonToDelete(personId);
    setOpenConfirmDeleteModal(true);
  };

  const handleConfirmDeleteGuardian = async () => {
    if (personToDelete) {
      try {
        const personToDeleteData = selectedPersons.find(p => p.idlocal === personToDelete);
        if (personToDeleteData) {
          let actualGranteeId = null;
          
          if (personToDeleteData.existAccount && personToDeleteData.id) {
            actualGranteeId = personToDeleteData.id;
          } else if (personToDeleteData.id && !personToDeleteData.id.toString().startsWith('local_')) {
            actualGranteeId = personToDeleteData.id;
          } else if (personToDeleteData.idlocal && personToDeleteData.idlocal.startsWith('local_')) {
            const extractedId = personToDeleteData.idlocal.replace('local_', '');
            if (extractedId && extractedId.trim() !== '' && extractedId !== model.id) {
              actualGranteeId = extractedId;
            }
          }
          
          if (actualGranteeId === model.id) {
            handleDeletePerson(personToDelete);
            setPersonToDelete(null);
            setOpenConfirmDeleteModal(false);
            return;
          }
          
          if (actualGranteeId && model.id && actualGranteeId !== model.id) {
            try {
              const deleteResponse = await sendRequest(
                `${CoreAPI_URLs.PERSONS_RELATION_GENERAL_OPERATIONS}/guardian/${model.id}/${actualGranteeId}`,
                null,
                "DELETE",
                undefined,
                [],
                { successMessage: t("personForm.guardianDeleted") }
              );
            } catch (apiError) {
              console.error("Error deleting guardian relation from backend:", apiError);
            }
          }
          handleDeletePerson(personToDelete);
        }
        
        setPersonToDelete(null);
      } catch (error) {
        console.error("🗑️ Error in handleConfirmDeleteGuardian:", error);
        handleDeletePerson(personToDelete);
        setPersonToDelete(null);
      }
    }
    setOpenConfirmDeleteModal(false);
  };
  
  const handleCloseConfirmDeleteModal = () => {
    setPersonToDelete(null);
    setOpenConfirmDeleteModal(false);
  };
  
  const handleCloseErrorDeleteGuardianModal = () => {
    setOpenErrorDeleteGuardianModal(false);
    setFormKey((prevKey) => prevKey + 1);
  };

  useEffect(() => {
    const updatedPersons = selectedPersons.map((person) => {
      person.responsible = mainPersonRelationIds.includes(person.idlocal);
      return person;
    });

    setSelectedPersons(updatedPersons);
  }, [mainPersonRelationIds]);

  const addUserParentCheckHandler = (event: ChangeEvent<HTMLInputElement>) => {
    const checked = event.currentTarget.checked;
    setAddUserParentChecked(checked);
  };

  const checkUsername = async (username: string) => {
    const url = `${CoreAPI_URLs.USERS_GENERAL_OPERATIONS}?username=${username}`;
    const request = await sendRequest(url, null, "GET");
  };

  /**
   * Handles form submission for person data
   * 
   * @param values - Person form values to submit
   * @param setFieldValue - Formik's setFieldValue function (required to prevent phone duplication bug)
   * 
   * Workflow:
   * 1. Filters empty emergency contacts and phones
   * 2. Updates Formik state to maintain UI consistency (ensures at least one empty phone input)
   * 3. Validates phone numbers
   * 4. Checks if minor without guardians
   * 5. Submits to backend or passes to next step
   */
  const submitHandler = async (
    values: Partial<PersonInterface>, 
    setFieldValue: (field: string, value: unknown) => void
  ) => {
    values.emergencyContacts =
      values.emergencyContacts?.filter((emergencyContact) => emergencyContact.name.trim() !== "") ||
      [];
  
    const filteredPhones = values.phones?.filter((phone) => phone.number.trim() !== "") || [];
    
    const phonesForFormState = filteredPhones.length > 0 ? filteredPhones : [{ number: "", idx: "1" }];
    
    setFieldValue('phones', phonesForFormState);
    
    values.phones = filteredPhones;
    
    values.emergencyContacts.forEach((contact) => {
      if (contact.phone) {
        contact.phone = validatePhoneInputSymbol(contact.phone);
      }
    });
    values.phones.forEach((phone) => {
      if (phone.number) {
        phone.number = validatePhoneInputSymbol(phone.number);
      }
    });
    if (values.dob) {
      try {
        const date = new Date(values.dob);
        if (isNaN(date.getTime())) {
          console.error('Invalid date:', values.dob);
          return;
        }
        values.dob = date.toISOString().split('T')[0];
      } catch (error) {
        console.error('Error formatting date:', error);
        return;
      }
    }
    if (selectedPersons && selectedPersons.length > 0) {
      selectedPersons.forEach(guardian => {
        if (guardian.dob) {
          try {
            const date = new Date(guardian.dob);
            if (!isNaN(date.getTime())) {
              guardian.dob = date.toISOString().split('T')[0];
            }
          } catch (error) {
            console.error('Error formatting guardian date:', error);
          }
        }
      });
    }
    if (verifyIsMinor(new Date(values.dob)) && !minorUserChecked) {
      setPreservedFormValues(values);
      handleOpenErrorMiniorModal();
      return;
    }
    if (nextStep) {
      if (!selectedPerson) {
        if (minorUserChecked) {
          if (selectedPersons.length > 0) {
            nextStep(values, true, selectedPersons);
          } else {
            handleOpenErrorModal();
            return;
          }
        } else {
          nextStep(values);
        }
      } else {
        nextStep(values);
      }
    } else {
      try {
        const method: Method = action === FormActionType.NEW ? "POST" : "PUT";
        const originalValues = JSON.parse(JSON.stringify(values));
        if (newImage) {
          delete values.photo;
        }
        const updatedPerson = await sendRequest(
          CoreAPI_URLs.PERSONS_GENERAL_OPERATIONS,
          onPersonUpdateHandler,
          method,
          JSON.stringify(values),
          [{ header: HeaderEnum.RESOURCE_ID, value: values.id }],
          { successMessage: t("personForm.personWasSaved") }
        );
        
        if (updatedPerson?.data?.id) {
          model.id = updatedPerson.data.id;
        }
        
        if (newImage && updatedPerson?.data) {
          await handlePhotoUpdate(updatedPerson.data, originalValues);
        }
        
        if (minorUserChecked && selectedPersons.length > 0 && model.id) {          
          await updateGuardiansHandler(selectedPersons);
        }
        if (updateListHandler && updatedPerson?.data) {
          updateListHandler(updatedPerson.data);
        }
      } catch (error) {
        console.error('Error in submitHandler:', error);
      }
    }
  };

  const handlePhotoUpdate = async (person: PersonInterface, originalValues: Partial<PersonInterface>) => {
    try {
      const personId = person?.id || model.id; 
      if (!personId) {
        console.error('No valid person ID for photo update');
        return;
      }
      const data = {
        mimetype: newImage.type,
        source: MediaSourceEnum.OTHER,
        category: MediaCategoryEnum.PROFILE,
        orgName: newImage.name,
        status: MediaStatusEnum.PENDING,
      };

      const responseAsset = await sendRequest<AssetInterface>(
        CoreAPI_URLs.ASSETS,
        null,
        "POST",
        JSON.stringify(data)
      );

      if (responseAsset?.data) {
        const formData = new FormData();
        formData.append("file", newImage);
        
        const responseAssetUpload = await sendRequest<AssetInterface>(
          CoreAPI_URLs.ASSETS_UPLOAD,
          null,
          "POST",
          formData,
          [{ header: HeaderEnum.RESOURCE_ID, value: responseAsset.data.id }]
        );

        if (responseAssetUpload?.data) {
          const updatedPersonData = {
            id: personId,
            name: originalValues.name,
            lastname: originalValues.lastname,
            prefix: originalValues.prefix,
            suffix: originalValues.suffix,
            mi: originalValues.mi,
            identity: originalValues.identity,
            sex: originalValues.sex,
            dob: originalValues.dob,
            phones: originalValues.phones,
            previousName: originalValues.previousName,
            address: originalValues.address,
            city: originalValues.city,
            state: originalValues.state,
            county: originalValues.county,
            zip: originalValues.zip,
            country: originalValues.country,
            ethnicity: originalValues.ethnicity,
            emergencyContacts: originalValues.emergencyContacts || [],
            isActive: originalValues.isActive !== undefined ? originalValues.isActive : true,
            photo: responseAssetUpload.data
          };
          const updatedPersonResponse = await sendRequest<PersonInterface>(
            CoreAPI_URLs.PERSONS_GENERAL_OPERATIONS,
            null,
            "PUT",
            JSON.stringify(updatedPersonData),
            [{ header: HeaderEnum.RESOURCE_ID, value: personId }],
            { successMessage: t("personForm.photoUpdated") }
          );

          if (updatedPersonResponse?.data) {
            if (updatedPersonResponse.data.photo) {
              model.photo = updatedPersonResponse.data.photo;
              setPhotoUpdateKey(prev => prev + 1);
            }
            if (previewImageUrl) {
              URL.revokeObjectURL(previewImageUrl);
              setPreviewImageUrl(null);
            }
            if (updateListHandler) {
              updateListHandler(updatedPersonResponse.data);
            }
          }
          
          setNewImage(null);
        }
      }
    } catch (error) {
      console.error("Error updating photo:", error);
    }
  };

  const handleImageChange = (file: File | null) => {
    setNewImage(file);
    if (previewImageUrl) {
      URL.revokeObjectURL(previewImageUrl);
    }
    if (file) {
      const imageUrl = URL.createObjectURL(file);
      setPreviewImageUrl(imageUrl);
    } else {
      setPreviewImageUrl(null);
    }
    
    if (setImage && typeof setImage === 'function') {
      setImage(file);
    }
  };

  useEffect(() => {
    return () => {
      if (previewImageUrl) {
        URL.revokeObjectURL(previewImageUrl);
      }
    };
  }, [previewImageUrl]);

  const updateGuardiansHandler = async (guardians: ExtendedPersonInterface[]) => {
    try {
      
      if (!model.id) {
        return;
      }
      
      const hasMainGuardian = guardians.some(g => g.responsible === true);
      if (!hasMainGuardian && guardians.length > 0) {
        guardians[0].responsible = true;
      }
      
      const guardiansToProcess = [];
      
      for (const guardian of guardians) {
        if (!guardian || !guardian.name || !guardian.lastname) {
          console.warn('Skipping invalid guardian:', guardian);
          continue;
        }

        const relationship = guardian.relationship in PersonRelationType
        ? guardian.relationship 
        : PersonRelationType.GUARDIAN;

        const currentDate = new Date().toISOString();
        let targetGranteeId = null;
        
        if (guardian.existAccount && guardian.id) {
          targetGranteeId = guardian.id;
        } else if (guardian.id && guardian.id !== '') {
          targetGranteeId = guardian.id;
        } else if (guardian.idlocal && guardian.idlocal.startsWith('local_')) {
          const extractedId = guardian.idlocal.replace('local_', '');
          if (extractedId && !isNaN(Number(extractedId))) {
            targetGranteeId = extractedId;
          }
        }

        if (targetGranteeId) {
          const relationData = {
            grantor: { id: model.id },
            grantee: { id: targetGranteeId },
            relationship: relationship,
            customRelationship: guardian.other || null,
            comments: guardian.comment || null,
            mainGrantee: Boolean(guardian.responsible),
            grantDate: currentDate,
            expirationDate: new Date(Date.now() + (365 * 24 * 60 * 60 * 1000)).toISOString()
          };
          
          guardiansToProcess.push(relationData);
        }
      }
      if (guardiansToProcess.length > 0) {
        
        await sendRequest(
          `${CoreAPI_URLs.PERSONS_RELATION_GENERAL_OPERATIONS}/bulk-update`,
          onPersonUpdateHandler,
          "PUT",
          JSON.stringify(guardiansToProcess),
          [{ header: HeaderEnum.RESOURCE_ID, value: model.id }],
          { successMessage: t("personForm.guardiansUpdated") }
        );
      }
    } catch (error) {
      console.error("Error updating guardians:", error);
    }
  };

  const onPersonUpdateHandler = (person: PersonInterface) => {
    updateListHandler(person);
  };

  const personOptions = useMemo<AutoCompleteOption[]>(
    () => {
      if (!personList || !Array.isArray(personList)) {
        return [];
      }
      
      return personList
        .filter((p) => {
          if (!p || !p.id) return false; 
          
          const isAlreadySelected = selectedPersons.some((selectedPerson) => 
            selectedPerson && (
              selectedPerson.id === p.id || 
              selectedPerson.idlocal === `local_${p.id}`
            )
          );
          return !isAlreadySelected;
        })
        .map((p) => {
          return {
            id: p.id,
            label: ((p.name || "") + " " + (p.lastname || "")).trim().toUpperCase() || t("personForm.noName"),
          };
        });
    },
    [personList, selectedPersons]
  );

  const onSelectPersonHandler = (
    _event: SyntheticEvent<Element, Event>,
    newValue: AutoCompleteOption
  ) => {
    if (newValue) {
      setSelectedPerson(personList.find((p) => p.id === newValue.id));
    } else {
      setSelectedPerson(undefined);
    }
  };

  const handleAddOrSelectParent = async (
    _event: SyntheticEvent<Element, Event>,
    newValue: AutoCompleteOption | null,
    values: ExtendedPersonInterface
  ) => {
    const min = 1;
    const max = 100;
    const number = Math.floor(Math.random() * (max - min + 1)) + min;
  
    if (newValue) {
      if (!values.relationship) {
        handleOpenErrorAddModal();
        return;
      } else {
        const selectedPerson = personList.find((p) => p.id === newValue.id);
        if (selectedPerson) {
          setSelectedPersons((prevSelectedPersons) => [
            ...prevSelectedPersons,
            {
              ...selectedPerson,
              username: selectedPerson.user?.username || "NA",
              email: selectedPerson.user?.email || "NA",
              idlocal: "local_" + selectedPerson.id,
              relationship: values.relationship,
              other: values.other,
              comment: values.comment,
              existAccount: true,
              responsible: false,
            },
          ]);
          values.relationship = "";
          values.other = "";
          values.comment = "";
        }
      }
    } else {
      if (!values.relationship) {
        handleOpenErrorAddModal();
        return;
      }
  
      const requiredFieldsFilled = [
        values.name,
        values.lastname,
        values.email,
        values.username,
        values.sex,
        values.identity,
      ].every((field) => field !== "");
  
      const url = `${CoreAPI_URLs.USERS_GENERAL_OPERATIONS}?username=${values.username}`;
      const request = await sendRequest(url, null, "GET");
  
      if (request?.data?.length > 0) {
        setMessageUsernameFlag(true);
        handleOpenErrorModal();
        return;
      }
  
      if (!requiredFieldsFilled) {
        handleOpenErrorModal();
        return;
      }
  
      const basePerson = {
        ...values,
        idlocal: "local_" + values.username,
        existAccount: false,
        responsible: false,
      };
  
      const newParent: ExtendedPersonInterface = values.phone
        ? {
            ...basePerson,
            phones: [{ number: values.phone, idx: "1" }],
          }
        : basePerson;
  
      setSelectedPersons((prevSelectedPersons) => [...prevSelectedPersons, newParent]);
  
      const resetFields = () => {
        values.relationship = "";
        values.name = "";
        values.lastname = "";
        values.dob = "";
        values.phone = "";
        values.username = "";
        values.email = "";
        values.other = "";
        values.comment = "";
        values.identity = "";
        values.sex = "";
        values.address = "";
        values.city = "";
        values.state = "";
        values.county = "";
        values.country = "";
        values.zip = "";
        setAddUserParentChecked(false);
        setDifferentAddressChecked(false);
      };
  
      resetFields();
    }
  };

  const handleEditPerson = (
    person: ExtendedPersonInterface,
    setFieldValue: (field: string, value: any, shouldValidate?: boolean) => void
  ) => {
    setAddUserParentChecked(true);
    setFieldValue("relationship", person.relationship);
    setFieldValue("name", person.name);
    setFieldValue("lastname", person.lastname);
    setFieldValue("dob", person.dob);
    setFieldValue("phone", person.phones?.[0]?.number || "");
    setFieldValue("username", person.username);
    setFieldValue("email", person.email);
    setFieldValue("other", person.other);
    setFieldValue("comment", person.comment);
    setFieldValue("identity", person.identity);
    setFieldValue("sex", person.sex);

    const hasAddress =
      person.address ||
      person.city ||
      person.state ||
      person.county ||
      person.country ||
      person.zip;

    if (hasAddress) {
      setDifferentAddressChecked(true);
      setFieldValue("address", person.address || "");
      setFieldValue("city", person.city || "");
      setFieldValue("state", person.state || "");
      setFieldValue("county", person.county || "");
      setFieldValue("country", person.country || "");
      setFieldValue("zip", person.zip || "");
    } else {
      setDifferentAddressChecked(false);
    }
    handleDeletePerson(person.idlocal);
  };

  const handleDeletePerson = (personId: string) => {
    setSelectedPersons((prevSelectedPersons) =>
      prevSelectedPersons.filter((person) => person.idlocal !== personId)
    );
  };

  const handleOpenErrorModal = () => {
    setOpenErrorModal(true);
  };
  

  const handleCloseErrorModal = () => {
    setOpenErrorModal(false);
    setMessageUsernameFlag(false);
  };

  const handleOpenErrorMiniorModal = () => {
    setOpenErrorMiniorModal(true);
  };

  const handleCloseErrorMiniorModal = () => {
    setOpenErrorMiniorModal(false);
    setFormKey((prevKey) => prevKey + 1);
  };

  const handleOpenErrorGuardianModal = () => {
    setOpenErrorGuardianModal(true);
  };

  const handleCloseErrorGuardianModal = () => {
    setOpenErrorGuardianModal(false);
  };

  const handleOpenErrorAddModal = () => {
    setOpenErrorAddModal(true);
  };

  const handleCloseErrorAddModal = () => {
    setOpenErrorAddModal(false);
  };

  return (
    <>
      <FormikForm
        key={formKey}
        onSubmit={(values, formikHelpers) => {
          submitHandler(values, formikHelpers.setFieldValue);
        }}
        initialValues={preservedFormValues || model}
        validationSchema={
          !existPersonChecked ? personFormYUPValidation(t, minorUserChecked) : undefined
        }
      >
        {({ values, errors, touched, setFieldValue, handleSubmit }: FormikProps<Partial<PersonInterface>>) => {
          return (
            <Form id="personForm" autoComplete="true">
              <Stack alignItems="center" direction="row" gap={2} mb={3}>
                <FolderSharedIcon fontSize="large" />
                <Typography variant="h4">{t("personForm.personalData")}</Typography>
              </Stack>
              <Grid container justifyContent="space-between" mb={2}>
                {type === UserRolesEnum.PATIENT && !existPersonChecked && (
                  <Stack alignItems="center" direction="row" gap={1}>
                    <Checkbox
                      label={t("personForm.minorUser")}
                      name="minorUserChecked"
                      value={minorUserChecked}
                      checked={minorUserChecked}
                      onChange={minorUserCheckHandler}
                    />
                  </Stack>
                )}
                {!values.id && !minorUserChecked && (
                  <Stack alignItems="center" direction="row" gap={1}>
                    <Checkbox
                      label={t("personForm.alreadyRegistered")}
                      name="registered"
                      checked={existPersonChecked}
                      onChange={existsPersonelCheckHandler}
                    />
                  </Stack>
                )}
              </Grid>
              {existPersonChecked ? (
                <Grid container sx={{ minWidth: "50rem" }} spacing={2}>
                  <Grid item xs={12} md={6} lg={4}>
                    <Box width="100%">
                      <Autocomplete
                        disablePortal
                        id="user-type-select"
                        options={personOptions}
                        onChange={onSelectPersonHandler}
                        renderInput={(params) => (
                          <TextField {...params} label={t("personForm.selectUser")} />
                        )}
                      />
                    </Box>
                  </Grid>
                </Grid>
              ) : (
                <>
                  <Grid container spacing={2}>
                  <Grid item xs={12}>
                    {values.id && (
                      <Stack direction="row" spacing={2}>
                        {photoLoading ? (
                          <Box sx={{ 
                            display: 'flex', 
                            flexDirection: 'column',
                            justifyContent: 'center', 
                            alignItems: 'center', 
                            width: 200,
                            height: 200,
                            border: '1px solid #e0e0e0',
                            borderRadius: '50%',
                            backgroundColor: '#f5f5f5'
                          }}>
                            <Box sx={{ position: 'relative', display: 'inline-flex' }}>
                              <CircularProgress 
                                variant="determinate" 
                                value={progress}
                                size={80}
                                thickness={4}
                                sx={{ color: 'primary.main' }}
                              />
                              <Box
                                sx={{
                                  top: 0,
                                  left: 0,
                                  bottom: 0,
                                  right: 0,
                                  position: 'absolute',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                }}
                              >
                                <Typography 
                                  variant="h6" 
                                  component="div" 
                                  color="secondary"
                                >
                                  {`${progress}%`}
                                </Typography>
                              </Box>
                            </Box>
                            <Typography 
                              variant="body2" 
                              color="secondary" 
                              sx={{ mt: 2 }}
                            >
                              {t("personForm.loadingPhoto")}
                            </Typography>
                          </Box>
                        ) : (previewImageUrl || currentPhotoUrl) ? (
                          <Avatar
                            alt={values.photo?.orgName || "Profile image"}
                            src={previewImageUrl || currentPhotoUrl}
                            sx={{ width: 200, height: 200 }}
                          />
                        ) : null}
                      </Stack>
                    )}
                    <Typography variant="caption" mr={1}>
                      {t("personForm.selectPersonImage")}
                    </Typography>
                    <InputFileUpload 
                      accept="image/*" 
                      setImage={handleImageChange} 
                      addNewImage={firstStep} 
                    />
                  </Grid>
                    <Grid item xs={12} md={6} lg={4}>
                      <FormSelectInput
                        name="prefix"
                        label={t("personForm.prefix")}
                        selectArray={prefixSelectOptions}
                        defaultValue={values.prefix ?? null}
                      />
                    </Grid>
                    <Grid item xs={12} md={6} lg={4}>
                      <FormField
                        type="text"
                        label={t("personForm.name")}
                        name="name"
                        value={values.name || ""}
                        error={errors.name && touched.name}
                      />
                    </Grid>
                    <Grid item xs={12} md={6} lg={4}>
                      <FormField
                        type="text"
                        label={t("personForm.mi")}
                        name="mi"
                        value={values.mi || ""}
                        error={errors.mi && touched.mi}
                      />
                    </Grid>
                    <Grid item xs={12} md={6} lg={4}>
                      <FormField
                        type="text"
                        label={t("personForm.lastName")}
                        name="lastname"
                        value={values.lastname || ""}
                        error={errors.lastname && touched.lastname}
                      />
                    </Grid>
                    <Grid item xs={12} md={6} lg={4}>
                      <FormSelectInput
                        name="suffix"
                        label={t("personForm.suffix")}
                        selectArray={suffixSelectOptions}
                      />
                    </Grid>
                    {readyForPicker && (
                  <Grid item xs={12} md={6} lg={4}>
                    <Stack alignItems="flex-end" direction="row" gap={1}>
                      <DatePicker
                        key={datePickerKey}
                        name="dob"
                        label={t('personForm.dateOfBirth')}
                        value={values.dob || ""}
                        onChange={(date) => {
                          setFieldValue('dob', date);
                        }}
                        error={errors.dob && touched.dob}
                        options={{
                          enableTime: false,
                          dateFormat: "Y-m-d",
                          closeOnSelect: true,
                          clickOpens: true,
                          allowInput: false,
                        }}
                        renderInput={(params) => (
                        <TextField
                          {...params}
                          error={!!(errors.dob && touched.dob)}
                          helperText={errors.dob && touched.dob ? errors.dob : ''}
                        />
                      )}
                      />
                    </Stack>
                  </Grid> )}
                  <Grid item xs={12} md={6} lg={4}>
                    <FormSelectInput
                      name="sex"
                      label={t("personForm.sexAssignedAtBirth")}
                      selectArray={sexListOptions}
                      value={values.sex}
                    />
                  </Grid>
                  <Grid item xs={12} md={6} lg={4}>
                    <FormField
                      type="text"
                      label={t("personForm.ethnicity")}
                      name="ethnicity"
                      value={values.ethnicity || ""}
                      error={errors.ethnicity && touched.ethnicity}
                    />
                  </Grid>
                  {!minorUserChecked && (
                    <Grid item xs={12} md={6} lg={4}>
                      <FormField
                        type="text"
                        label={t("personForm.identity")}
                        name="identity"                        
                        value={values.identity}
                        error={errors.identity && touched.identity}
                        onChange={(e) => {
                          const upperValue = e.target.value.toUpperCase();
                          setFieldValue('identity', upperValue);
                        }}
                      />
                    </Grid>
                  )}
                  <FieldArray name="phones">
                    {({ remove, push, form }) => {
                      if (values.phones.length === 0) {
                        push({ number: "", idx: "1" });
                        return null;
                      }

                      return (
                        <>
                          {values.phones.map((phone, index) => (
                            <Grid
                              key={`phone-${phone.idx || index}`}
                              item
                              xs={12}
                              md={6}
                              lg={8}
                              sx={{ display: "flex", alignItems: "center", gap: 1 }}
                            >
                              <Box sx={{ flex: 1 }}>
                                <FormPhoneInput
                                  specialLabel={`${t("personForm.phone")} #${index + 1}`}
                                  country={"us"}
                                  required={false}
                                  name={`phones[${index}].number`}
                                  value={phone.number || ""}
                                  onChange={(value) => {
                                    form.setFieldValue(`phones[${index}].number`, value);
                                  }}
                                  inputStyle={{
                                    width: "100%",
                                    boxSizing: "border-box",
                                    fontSize: "1rem",
                                    paddingRight: "0",
                                  }}
                                />
                              </Box>
                              <IconButton
                                type="button"
                                onClick={() => {
                                  remove(index);
                                  if (values.phones.length === 1) {
                                    push({ number: "", idx: "1" });
                                  } else {
                                    const updatedPhones = [...values.phones];
                                    updatedPhones.splice(index, 1);
                                    updatedPhones.forEach((p, i) => {
                                      p.idx = (i + 1).toString();
                                    });
                                    form.setFieldValue("phones", updatedPhones);
                                  }
                                }}
                                disabled={values.phones.length === 1}
                                color="error"
                                aria-label="remove phone"
                              >
                                <RemoveIcon />
                              </IconButton>
                              {index === values.phones.length - 1 && (
                                <IconButton
                                  type="button"
                                  onClick={() => {
                                    const newPhone = {
                                      number: "",
                                      idx: (values.phones.length + 1).toString(),
                                    };
                                    push(newPhone);
                                  }}
                                  color="primary"
                                  aria-label="add phone"
                                >
                                  <AddIcon />
                                </IconButton>
                              )}
                            </Grid>
                          ))}
                        </>
                      );
                    }}
                  </FieldArray>
                  <Grid item xs={12} md={6} lg={4}>
                    <FormField
                      type="text"
                      label={t("personForm.previousName")}
                      name="previousName"
                      value={values.previousName || ""}
                    />
                  </Grid>
                  <Grid item xs={12} md={6} lg={4}>
                    <FormField
                      multiline
                      label={t("personForm.address")}
                      name="address"
                      value={values.address || ""}
                    />
                  </Grid>
                  <Grid item xs={12} md={6} lg={4}>
                    <FormField
                      type="text"
                      label={t("personForm.city")}
                      name="city"
                      value={values.city || ""}
                    />
                  </Grid>
                  <Grid item xs={12} md={6} lg={4}>
                    <FormField
                      type="text"
                      label={t("personForm.state")}
                      name="state"
                      value={values.state || ""}
                    />
                  </Grid>
                  <Grid item xs={12} md={6} lg={4}>
                    <FormField
                      type="text"
                      label={t("personForm.county")}
                      name="county"
                      value={values.county || ""}
                    />
                  </Grid>
                  <Grid item xs={12} md={6} lg={4}>
                    <FormField
                      type="text"
                      label={t("personForm.country")}
                      name="country"
                      value={values.country || ""}
                    />
                  </Grid>
                  <Grid item xs={12} md={6} lg={4}>
                    <FormField
                      type="text"
                      label={t("personForm.zipCode")}
                      name="zip"
                      value={values.zip || ""}
                    />
                  </Grid>
                </Grid>
                <Grid container justifyContent="space-between" mb={2}>
                  <Stack alignItems="center" direction="row" gap={1}>
                    <Checkbox
                      id="cy-emergency-contacts"
                      label={t("personForm.emergencyContacts")}
                      name="emergencyContacts"
                      checked={emergencyContactsChecked}
                      onChange={emergencyContactsCheckHandler}
                    />
                  </Stack>
                </Grid>
                {emergencyContactsChecked && (
                <Grid container spacing={2}>
                  <FieldArray name="emergencyContacts">
                    {({ remove, push, form }) => {
                      if (values.emergencyContacts.length === 0) {
                        values.emergencyContacts.push({
                          name: "",
                          lastname: "",
                          relation: "",
                          phone: "",
                        });
                      }
                      return (
                        <>
                          {values.emergencyContacts.length > 0 &&
                            values.emergencyContacts.map((contact, index) => (
                              <Grid
                                key={`per.name.${index}-${String(contact)}`}
                                item
                                xs={12}
                                md={6}
                                lg={4}
                                sx={{ display: "flex", flexDirection: "column", gap: 1 }}
                              >
                                <FormField
                                  type="text"
                                  label={t("personForm.name")+` #${index + 1}`}
                                  name={`emergencyContacts[${index}].name`}
                                  fullWidth
                                />
                                <FormField
                                  type="text"
                                  label={t("personForm.lastname")+` #${index + 1}`}
                                  name={`emergencyContacts[${index}].lastname`}
                                  fullWidth
                                />
                                <FormField
                                  type="text"
                                  label={t("personForm.relation")+` #${index + 1}`}
                                  name={`emergencyContacts[${index}].relation`}
                                  fullWidth
                                />
                                <FormPhoneInput
                                  inputClass="emergencyPhone"
                                  specialLabel={t("personForm.phoneNumber")+` #${index + 1}`}
                                  country={"us"}
                                  required={false}
                                  name={`emergencyPhone`}
                                  value={values.emergencyContacts[index].phone}
                                  onChange={(value) => {
                                    form.setFieldValue(`emergencyContacts[${index}].phone`, value);
                                  }}
                                  inputStyle={{
                                    width: "100%",
                                    boxSizing: "border-box",
                                    fontSize: ".8rem",
                                    paddingRight: "0",
                                  }}
                                />
                                <Box sx={{ display: "flex", gap: 1, justifyContent: "flex-start" }}>
                                  <IconButton
                                    type="button"
                                    onClick={() => {
                                      if (values.emergencyContacts.length === 1) {
                                        form.setFieldValue(`emergencyContacts[${index}].name`, "");
                                        form.setFieldValue(`emergencyContacts[${index}].lastname`, "");
                                        form.setFieldValue(`emergencyContacts[${index}].relation`, "");
                                        form.setFieldValue(`emergencyContacts[${index}].phone`, "");
                                      } else {
                                        remove(index);
                                      }
                                    }}
                                    disabled={false}
                                    color="error"
                                    aria-label="remove emergency contact"
                                  >
                                    <RemoveIcon />
                                  </IconButton>
                                  {index === values.emergencyContacts.length - 1 && (
                                    <IconButton
                                      type="button"
                                      onClick={() =>
                                        push({
                                          name: "",
                                          lastname: "",
                                          relation: "",
                                          phone: "",
                                        })
                                      }
                                      color="primary"
                                      aria-label="add emergency contact"
                                    >
                                      <AddIcon />
                                    </IconButton>
                                  )}
                                </Box>
                              </Grid>
                            ))}
                        </>
                      );
                    }}
                  </FieldArray>
                </Grid>
              )}
              </>
            )}
            {checkFormValidity(values, errors, touched) && (
                <Box mt={2} mb={2}>
                  <Typography 
                    variant="body2" 
                    sx={{ 
                      color: 'red',
                      textAlign: 'center'
                    }}
                  >
                    {checkFormValidity(values, errors, touched)}
                  </Typography>
                </Box>
              )}
            <StepperFormActionButtons
              backStepHandler={backStepHandler}
              nextStep={nextStep}
              firstStep={firstStep}
              lastStep={isEffectiveLastStep}
              isLoading={isLoading}
              disabledSubmit={existPersonChecked && !selectedPerson}
              minorUserChecked={minorUserChecked}
            />
          </Form>
          );
        }}
      </FormikForm>
      <Divider />
      {minorUserChecked && (
        <FormikForm
        onSubmit={(values) => {
          const age = calculateAge(getFromISOYYYYMMDDDateFormat(new Date(values.dob)));
          if (age < 18) {
            handleOpenErrorGuardianModal();
            return;
          }
          handleAddOrSelectParent(null, null, values);
        }}
          initialValues={parentData}
          validationSchema={personParentFormYUPValidation(t)}
        >
          {({ values, errors, touched, isSubmitting, setFieldValue }) => (
            <Form id="personParentForm" autoComplete="true">
              <Stack alignItems="center" direction="row" gap={2} mb={3}>
                <FolderSharedIcon fontSize="large" />
                <Typography variant="h4">
                  {t("personForm.personalDataOfTheParentGuardian")}
                </Typography>
              </Stack>
              <Grid container spacing={2} mb={1}>
                <Grid item xs={12} id="cy-user-parent-relationship-select">
                  <Box width="100%">
                    <FormSelectInput
                      name="relationship"
                      label={t("personForm.relationship")}
                      selectArray={relationshipOptions}
                      value={values.relationship}
                    />
                  </Box>
                </Grid>
                {values.relationship === "OTHER" && (
                  <Grid item xs={12}>
                    <FormField
                      type="text"
                      label="Other"
                      name="other"
                      id="other"
                      value={values.other}
                    />
                  </Grid>
                )}
                <Grid item xs={12}>
                  <FormField
                    type="text"
                    label={t("personForm.comments")}
                    name="comment"
                    id="comments"
                    value={values.comment}
                  />
                </Grid>
                {!addUserParentChecked && (
                  <Grid item xs={12} id="cy-user-parent-type-select">
                    <Box width="100%">
                      <Autocomplete
                        disablePortal
                        options={personOptions}
                        value={null}
                        onChange={(event, newValue) => {
                          handleAddOrSelectParent(event, newValue, values);
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label={t("personForm.selectParent_GuardianAcount")}
                          />
                        )}
                      />
                    </Box>
                  </Grid>
                )}
                <Grid item xs={12} sm={8}>
                  <Stack alignItems="center" direction="row" gap={1}>
                    <Checkbox
                      id="cy-add-user-parent"
                      label={t("personForm.addUserParentGuardian")}
                      name="add-user-parent"
                      checked={addUserParentChecked}
                      onChange={addUserParentCheckHandler}
                    />
                  </Stack>
                </Grid>
              </Grid>
              {addUserParentChecked && (
                <Grid container spacing={2}>
                  <Grid item xs={12} md={6} lg={4}>
                    <FormField
                      type="text"
                      label={t("personForm.name")}
                      name="name"
                      id="nameParent"
                      value={values.name}
                    />
                  </Grid>
                  <Grid item xs={12} md={6} lg={4}>
                    <FormField
                      type="text"
                      label={t("personForm.lastName")}
                      name="lastname"
                      id="lastnameParent"
                      value={values.lastname}
                    />
                  </Grid>
                  <Grid item xs={12} md={6} lg={4}>
                    <Stack alignItems="flex-end" direction="row" gap={1}>
                      <DatePicker
                        name="dob"
                        label={t('personForm.dateOfBirth')}
                        value={values.dob}
                        onChange={(date) => {
                          setFieldValue('dob', date);
                        }}
                        error={errors.dob && touched.dob}
                        options={{
                          enableTime: false,
                          dateFormat: "Y-m-d",
                        }}
                        renderInput={(params) => (
                        <TextField
                          {...params}
                          error={!!(errors.dob && touched.dob)}
                          helperText={errors.dob && touched.dob ? errors.dob : ''}
                        />
                      )}
                      />
                    </Stack>
                  </Grid>
                  <Grid item xs={12} md={6} lg={4}>
                    <FormSelectInput
                      name="sex"
                      label={t("personForm.sexAssignedAtBirth")}
                      selectArray={sexListOptions}
                      value={values.sex}
                    />
                  </Grid>
                  <Grid item xs={12} md={6} lg={4}>
                    <FormField
                      type="text"
                      label={t("personForm.identity")}
                      name="identity"
                      value={values.identity}
                      onChange={(e) => {
                        const upperValue = e.target.value.toUpperCase();
                        setFieldValue('identity', upperValue);
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} md={6} lg={4}>
                    <FormPhoneInput
                      specialLabel={t("personForm.phoneNumber")}
                      country={"us"}
                      required={false}
                      name="phone"
                      value={values.phone}
                      onChange={(value) => {
                        values.phone = value;
                      }}
                      inputStyle={{
                        width: "100%",
                        boxSizing: "border-box",
                        fontSize: ".8rem",
                        paddingRight: "0",
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} md={6} lg={4}>
                    <FormField
                      type="text"
                      label={t("personForm.userName")}
                      name="username"
                      id="usernameParent"
                      value={values.username}
                    />
                  </Grid>
                  <Grid item xs={12} md={6} lg={4}>
                    <FormField
                      type="email"
                      label={t("personForm.email")}
                      name="email"
                      id="emailParent"
                      pattern=".+@example\.com"
                      value={values.email}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <Stack alignItems="center" direction="row" gap={1}>
                      <Checkbox
                        label={t("personForm.differentAddress")}
                        name="differentAddress"
                        checked={differentAddressChecked}
                        onChange={differentAddressCheckHandler}
                      />
                    </Stack>
                  </Grid>
                  {differentAddressChecked && (
                    <>
                      <Grid item xs={12} md={6} lg={4}>
                        <FormField
                          multiline
                          label={t("personForm.address")}
                          name="address"
                          value={values.address}
                        />
                      </Grid>
                      <Grid item xs={12} md={6} lg={4}>
                        <FormField
                          type="text"
                          label={t("personForm.city")}
                          name="city"
                          value={values.city}
                        />
                      </Grid>
                      <Grid item xs={12} md={6} lg={4}>
                        <FormField
                          type="text"
                          label={t("personForm.state")}
                          name="state"
                          value={values.state}
                        />
                      </Grid>
                      <Grid item xs={12} md={6} lg={4}>
                        <FormField
                          type="text"
                          label={t("personForm.county")}
                          name="county"
                          value={values.county}
                        />
                      </Grid>
                      <Grid item xs={12} md={6} lg={4}>
                        <FormField
                          type="text"
                          label={t("personForm.country")}
                          name="country"
                          value={values.country}
                        />
                      </Grid>
                      <Grid item xs={12} md={6} lg={4}>
                        <FormField
                          type="text"
                          label={t("personForm.zipCode")}
                          name="zip"
                          value={values.zip}
                        />
                      </Grid>
                    </>
                  )}
                  <Grid item xs={12} textAlign={"right"}>
                    <Button id="btnAddParent" variant="contained" color="info" type="submit">
                      {t("personForm.add")}
                    </Button>
                  </Grid>
                </Grid>
              )}
              {selectedPersons.length > 0 && (
                <Box mt={3}>
                  <Typography variant="h6">{t("personForm.selectedPersons")}</Typography>
                  <TableContainer component={Paper}>
                    <Table>
                      <TableHead sx={{ display: "table-header-group" }}>
                        <TableRow>
                          <TableCell>{t("personForm.mainAccount")}</TableCell>
                          <TableCell>{t("personForm.name")}</TableCell>
                          <TableCell>{t("personForm.lastName")}</TableCell>
                          <TableCell>{t("personForm.phone")}</TableCell>
                          <TableCell>{t("personForm.email")}</TableCell>
                          <TableCell>{t("personForm.relationship")}</TableCell>
                          <TableCell>{t("personForm.edit")}</TableCell>
                          <TableCell>{t("personForm.delete")}</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {selectedPersons.map((person) => (
                          <TableRow key={person.idlocal}>
                            <TableCell>
                              <Checkbox
                                checked={person.responsible}
                                onChange={() => handleResponsibleChange(person.idlocal)}
                                value={person.idlocal}
                                name="main-account"
                                label=""
                              />
                            </TableCell>
                            <TableCell>{person.name}</TableCell>
                            <TableCell>{person.lastname}</TableCell>
                            <TableCell>
                              {person.phones && person.phones.length > 0
                                ? person.phones[0].number
                                : "-"}
                            </TableCell>
                            <TableCell>{person.email ? person.email : person.user.email}</TableCell>
                            <TableCell>{person.relationship}</TableCell>
                            <TableCell>
                              {person.existAccount ? (
                                "-"
                              ) : (
                                <IconButton onClick={() => handleEditPerson(person, setFieldValue)}>
                                  <EditIcon />
                                </IconButton>
                              )}
                            </TableCell>
                            <TableCell>
                                <IconButton onClick={() => handleConfirmDelete(person.idlocal)}>
                                  <DeleteIcon />
                                </IconButton>
                            </TableCell>
                          </TableRow>
                        ))
                        }
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>
              )}
            </Form>
          )}
        </FormikForm>
      )}
      <Dialog 
        disableEnforceFocus 
        open={openErrorModal} 
        onClose={handleCloseErrorModal}>
        <DialogTitle id="error-dialog-title">{t('personForm.attention')}</DialogTitle>
        <DialogContent>
          <DialogContentText id="error-dialog-description">{messageUsernameFlag ? t('userForm.usernameAlreadyExist') : t('personForm.pleaseSelectOrAddParent')}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseErrorModal} color="primary">
            {t('personForm.ok')}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openErrorMiniorModal}
        onClose={handleCloseErrorMiniorModal}
        aria-labelledby="error-dialog-title-minor"
        aria-describedby="error-dialog-description"
        disableEnforceFocus
        keepMounted={false}
      >
        <DialogTitle id="error-dialog-title-minior">{t('personForm.minorRegistration')}</DialogTitle>
        <DialogContent>
          <DialogContentText id="error-dialog-description">{t('personForm.minorRegistrationDescription')}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseErrorMiniorModal} color="primary">
            {t('personForm.ok')}
          </Button>
        </DialogActions>
      </Dialog> 
     <Dialog
        open={openErrorGuardianModal}
        onClose={handleCloseErrorGuardianModal}
        aria-labelledby="error-dialog-title-minor"
        aria-describedby="error-dialog-description"
        disableEnforceFocus
        keepMounted={false}
        >
        <DialogTitle id="error-dialog-title-minior">{t('personForm.minorGuardian')}</DialogTitle>
        <DialogContent>
          <DialogContentText id="error-dialog-description">{t('personForm.minorGuardianDescription')}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseErrorGuardianModal} color="primary">
            {t('personForm.ok')}
          </Button>
        </DialogActions>
      </Dialog> 
      <Dialog
        open={openErrorAddModal}
        onClose={handleCloseErrorAddModal}
        aria-labelledby="error-dialog-title-minor"
        aria-describedby="error-dialog-description"
        disableEnforceFocus
        keepMounted={false}
        >
        <DialogTitle id="error-dialog-title-minior">{t('personForm.addAction')}</DialogTitle>
        <DialogContent>
          <DialogContentText id="error-dialog-description">{t('personForm.addActionDescription')}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseErrorAddModal} color="primary">
            {t('personForm.ok')}
          </Button>
        </DialogActions>
      </Dialog> 
      {/* Modal de confirmación para eliminar guardián */}
      <Dialog
      open={openConfirmDeleteModal}
      onClose={handleCloseConfirmDeleteModal}
      aria-labelledby="confirm-delete-dialog-title"
      aria-describedby="confirm-delete-dialog-description"
      disableEnforceFocus
      keepMounted={false}
    >
      <DialogTitle id="confirm-delete-dialog-title">{t('personForm.confirmDeleteGuardian')}</DialogTitle>
      <DialogContent>
        <DialogContentText id="confirm-delete-dialog-description">
          {t('personForm.confirmDeleteGuardianDescription')}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCloseConfirmDeleteModal} color="secondary">
          {t('common.cancel')}
        </Button>
        <Button onClick={handleConfirmDeleteGuardian} color="primary">
          {t('personForm.delete')}
        </Button>
      </DialogActions>
    </Dialog>

    {/* Modal de error - no se puede eliminar el último guardián */}
    <Dialog
      open={openErrorDeleteGuardianModal}
      onClose={handleCloseErrorDeleteGuardianModal}
      aria-labelledby="error-delete-guardian-dialog-title"
      aria-describedby="error-delete-guardian-dialog-description"
      disableEnforceFocus
      keepMounted={false}
    >
      <DialogTitle id="error-delete-guardian-dialog-title">{t('personForm.cannotDeleteGuardian')}</DialogTitle>
      <DialogContent>
        <DialogContentText id="error-delete-guardian-dialog-description">
          {t('personForm.cannotDeleteGuardianDescription')}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCloseErrorDeleteGuardianModal} color="primary">
          {t('personForm.ok')}
        </Button>
      </DialogActions>
    </Dialog>
    </>
  );
};

export default PersonForm;